export default __webpack_public_path__ + "static/media/roboto-cyrillic-ext-400-normal.493afe7a.woff2";